export interface ChatFile {
  fileName: string;
  encode: string;
  contentType: string;
  url: string | null | '';
  fileSize: number;
}
export enum allowedContentTypes {
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  JPG = 'image/jpg',
  JFIF = 'image/jfif',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  PDF = 'application/pdf',
  VIDEO = 'video/mp4',
  XLSXT1 = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XLSXT2 = 'application/vnd.ms-excel',
  TEXT_PLAIN = 'text/plain',
}
